import * as React from 'react';
import { useSelector } from 'react-redux';
import { StockFilters } from '../StockFilters';
import { featureFlagsSelector } from 'selectors/config';
import { EmptyList } from './components/EmptyList';
import { Content } from './components/Content';

export const StockList: React.FC = () => {
  const { stocksListPlug } = useSelector(featureFlagsSelector);

  if (stocksListPlug) {
    return <EmptyList />;
  }

  return (
    <>
      <StockFilters />
      <Content />
    </>
  );
};
